function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "30",
  cy: "30",
  r: "30",
  fill: "#fff",
  fillOpacity: ".8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#222",
  d: "M41.707 28.226c1.819 1.256 1.816 3.293 0 4.547l-14.414 9.953C25.474 43.982 24 43.207 24 40.998V20.002c0-2.21 1.477-2.983 3.293-1.729l14.414 9.953z"
}))));